const tab_sections = {
    overview: 'Visión general',
    authentication: 'Autenticación',
    authorization: 'Autorización',
    users: 'Usuarios',
    developer: 'Desarrollador',
    tenant: 'Inquilino',
};
export default Object.freeze(tab_sections);
